import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import PrintLocationLabel from 'components/Print/LocationLabel';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <PrintLocationLabel />
      </SiteContent>
    </ContentLayout>
  );
};
